import { useRbacStore } from '@/stores/rbacStore';

/**
 * Đây là một biến "private" để giữ instance của Pinia store.
 * Nó sẽ được khởi tạo là null.
 */
let _store = null;

/**
 * Đây là đối tượng RBAC "giả" (proxy) mà toàn bộ ứng dụng của bạn đang import.
 * Nó có tất cả các hàm và thuộc tính giống hệt object cũ.
 */
const RBAC = {
    
    /**
     * HÀM MỚI (Rất quan trọng):
     * Hàm này phải được gọi từ main.js, SAU KHI Pinia đã được cài đặt.
     * Nó nhận Pinia instance và khởi tạo _store.
     */
    init(piniaInstance) {
        if (_store) return; // Chỉ khởi tạo một lần
        _store = useRbacStore(piniaInstance);
    },

    /**
     * Dùng 'get' để biến các thuộc tính của store (state)
     * thành các thuộc tính của đối tượng RBAC.
     * Bất cứ ai gọi RBAC.loaded sẽ thực chất là gọi _store.loaded.
     */
    get loaded() {
        if (!_store) return false;
        return _store.loaded;
    },
    
    get permissions() {
        if (!_store) return new Set();
        return _store.permissions;
    },

    get apis() {
        if (!_store) return [];
        return _store.apis;
    },

    /**
     * Sửa lại các hàm cũ để chúng "ủy quyền" (delegate)
     * lệnh gọi cho _store.
     */
    
    // Hàm này sẽ gọi _store.loadMe()
    async loadMe() {
        if (!_store) return console.error("RBAC.init(pinia) chưa được gọi!");
        return _store.loadMe();
    },

    // Hàm này sẽ gọi _store.clear()
    clear() {
        if (!_store) return;
        _store.clear();
    },

    // Hàm này không cần thiết nữa vì Pinia không dùng localStorage,
    // nhưng chúng ta giữ lại để code cũ không bị lỗi khi gọi.
    hydrate() {
        // Không làm gì cả
    },

    // Các hàm helper này giờ cũng gọi qua _store
    hasPerm(code) {
        if (!_store) return false;
        return _store.hasPerm(code);
    },
    
    hasAll(arr = []) {
        if (!_store) return false;
        return _store.hasAll(arr);
    },
    
    hasAny(arr = []) {
        if (!_store) return false;
        return _store.hasAny(arr);
    },
    
    canApi(method, path) {
        if (!_store) return false;
        return _store.canApi(method, path);
    }
};

// Vẫn export default như cũ
export default RBAC;